import request from '@/common/js/request'

/**
 * 活动详情
 */
export const activityActivityIdGet = (option = {}) => {
    return request({
        url: '/apis/activity/{activityId}',
        method: 'get',
        ...option
    })
}

/**
 * 获取活动评论列表
 */
export const activityActivityIdRepliesGet = (option = {}) => {
    return request({
        url: '/apis/activity/{activityId}/replies',
        method: 'get',
        ...option
    })
}


/**
 * 发送活动评论
 */
export const activityActivityIdRepliesPost = (option = {}) => {
    return request({
        url: '/apis/activity/{activityId}/replies',
        method: 'post',
        ...option
    })
}
